import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthRoute, Switch, useRouteMatch, NavLink, Redirect } from '@fs/zion-router'
import { H5 } from '@fs/zion-ui'
import { usePageView } from '@fs/zion-analytics'
import { SubSubNav } from '../app/SubnavAndRoutes'
import QueuesList from './queuesList/QueuesList'
import { QueuesContextProvider } from './QueuesContext'
import { useQueues } from './useQueues'
import MessagesList from './messagesList/MessagesList'
import MessageDetails from './messageDetails/MessageDetails'
import { PermissionsContext } from '../app/PermissionsContext'
import RecentlyResolved from './recentlyResolved/RecentlyResolved'
import { usePageTitle } from '../app/PageTitleContext'

export default function QueuesBase() {
  usePageView({ page_detail: 'DMConsole:QueuesBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.queues.base'))
  const contextValue = useQueues()
  const match = useRouteMatch()

  const { isAuthorized } = useContext(PermissionsContext)
  if (!isAuthorized('ReadFailedMessagePermission')) {
    return <H5>{t('not.authorized.greeting', 'Not authorized')}</H5>
  }

  return (
    <QueuesContextProvider value={contextValue}>
      <SubSubNav bottomLine>
        <>
          <NavLink to={`${match.url}/message`}>{t('queues.messages', 'Messages Queues')}</NavLink>
          <NavLink to={`${match.url}/holocaust`}>{t('queues.holocaust', 'Holocaust')}</NavLink>
          <NavLink to={`${match.url}/famous`}>{t('famous', 'Famous')}</NavLink>
          <NavLink to={`${match.url}/historical`}>{t('historical', 'Historical')}</NavLink>
          <NavLink to={`${match.url}/fictional`}>{t('queues.fictional', 'Fictional')}</NavLink>
          <NavLink to={`${match.url}/inappropriate`}>{t('queues.inappro', 'Inappropriate')}</NavLink>
          <NavLink to={`${match.url}/sensitive`}>{t('sensitive', 'Sensitive')}</NavLink>
          <NavLink to={`${match.url}/gender`}>{t('gender.label', 'Gender')}</NavLink>
          <NavLink to={`${match.url}/reevaluate`}>{t('queues.reevaluate', 'Re-evaluate')}</NavLink>
          <NavLink to={`${match.url}/recently-resolved`}>{t('queues.recentlyResolved', 'Recently Resolved')}</NavLink>
        </>
      </SubSubNav>

      <Switch>
        <Redirect exact from={`${match.path}`} to={`${match.path}/message`} />
        <AuthRoute exact path={`${match.path}/recently-resolved`} component={RecentlyResolved} />
        <AuthRoute exact path={`${match.path}/:queuesFilter`} component={QueuesList} />
        <AuthRoute exact path={`${match.path}/:queuesFilter/:queueName`} component={MessagesList} />
        <AuthRoute exact path={`${match.path}/:queuesFilter/:queueName/:messageId`} component={MessageDetails} />
      </Switch>
    </QueuesContextProvider>
  )
}
